import { TIME_FORMAT } from './patterns.js';
import formatTZ from 'date-fns-tz/format';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';

/**
 * Formats `date` as time.
 *
 * Use this for UIs where displaying time is needed.
 *
 * - e.g. formatTime("2021-01-01T20:00:00.000Z", PACIFIC_TIME_ZONE) => "12:00 PM PST"
 */
function formatTime(date, ianaTimeZone) {
    let convertedDate = new Date(date);
    let timeFormatPattern = TIME_FORMAT;
    // if setting the time zone, convert the time to the zoned time and add the time zone format pattern
    if (ianaTimeZone) {
        convertedDate = utcToZonedTime(convertedDate, ianaTimeZone);
        timeFormatPattern += ' zzz';
    }
    return formatTZ(convertedDate, timeFormatPattern, { timeZone: ianaTimeZone });
}

export { formatTime };
//# sourceMappingURL=format-time.js.map
